// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circleCheck16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-check': IconCircleCheck;
    }
}

/**
 * The icon component for the 'circleCheck' icon
 */
export class IconCircleCheck extends Icon {
    public constructor() {
        super(circleCheck16X16);
    }
}

registerIcon('icon-circle-check', IconCircleCheck);
export const iconCircleCheckTag = 'nimble-icon-circle-check';
